import React from 'react';
import { InfoBox, InfoBoxContent, InfoIconWrapper } from './style';
import { ReactComponent as InfoIcon } from 'assets/images/SVG/icons/info-icon.svg';

export default function ReturnSourceInfo() {
  return (
    <div className='af-return-to-source-info-container'>
      <InfoBox className='af-return-to-source-info-box'>
        <InfoIconWrapper className='af-return-to-source-info-icon-wrap'>
          <InfoIcon className='af-return-to-source-info-icon' />
        </InfoIconWrapper>
        <InfoBoxContent className='af-return-to-source-info-content-wrap'>
          <p className='af-return-to-source-info-message return-to-source-info-message'>
            You must provide the source path in query string so the user will return back to the original URL when an
            action is completed.
          </p>
          <p className='af-return-to-source-info-message return-to-source-info-message-eg1'>
            Example: your link to forgot password page must be like,
          </p>
          <p className='af-return-to-source-info-message return-to-source-info-message-eg2'>
            https://adweb.com/forgotpassword?src=https://sourcedomain.com/page
          </p>
          <p className='af-return-to-source-info-message return-to-source-info-message-eg4'>
            http://adweb.com = replace with your AD Web URL.
          </p>
          <p className='af-return-to-source-info-message return-to-source-info-message-eg5'>
            https://sourcedomain.com/page = replace with the exact path you want to return back.
          </p>
        </InfoBoxContent>
      </InfoBox>
    </div>
  );
}
